"use client";
import { lazy as e } from "react";
//#region src/core/contract.ts
function t(e) {
	switch (e) {
		case "revealing": return "during";
		case "results": return "post";
		default: return "pre";
	}
}
function n(e) {
	return e;
}
//#endregion
//#region src/openers/registration.ts
var r = /* @__PURE__ */ new Map();
function i(e, t) {
	r.set(e, t);
}
function a(e) {
	return r.get(e);
}
function o(t, r) {
	return n({
		Opener: e(t),
		preload: () => {
			t();
		},
		stage: "all",
		loopTarget: "loop",
		supportsBulk: !1,
		revealExit: { lingerMs: {
			normal: 0,
			quick: 0
		} },
		tokens: r
	});
}
//#endregion
export { t as a, n as i, a as n, i as r, o as t };

//# sourceMappingURL=registration-BkPgmtZ2.js.map